import React, { useEffect, useState } from 'react'
import { TextField, Grid, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import RonadIcons from '../iconComponent';
import handleError from '../../utils/handleError';
import ContactsRepository from 'client-sdk/src/Repository/contacts-repository';

type Contact = {
  fullName: string,
  nationalCode: string,
  mobile: string,
  province: string,
  city: string,
  postalCode: string,
  address: string,
  lat: number,
  lon: number,
  description: string,
  id: number
};

type Props = {
  onDelete: (e:any, id:string) => void
  onSelect: (contact: Contact) => void
}

function ContactList({onDelete, onSelect}:Props) {
  const [filterContacts, setFilterContacts] = useState<Contact[]>([])
  const [contacts, setContacts] = useState<Contact[]>([])

  useEffect(() => {
    getContacts()
  }, [])

  const getContacts = async () => {
    try {
      const response = await ContactsRepository.getContacts({payload: {sort: "fullName,asc",size: 1000}});
      setContacts(response.data);
      setFilterContacts(response.data)
    } catch (error) {
      handleError(error);
    }
  };

  const onFilterContacts = (event: any) => {
    const newValue = event.target.value
    if(newValue === "") {
      setFilterContacts(contacts)
    }else {
      setFilterContacts(contacts.filter(el => el.fullName.includes(newValue)))
    }
  }

  return ( 
    <>
    <TextField 
    fullWidth 
    placeholder='نام مخاطب'
    variant='outlined'
    style={{marginBottom: "12px"}}
    onChange={onFilterContacts}
  />
  {filterContacts.length > 0 ? filterContacts.map((el: any, index: number) => (
    <Grid
      container
      className="card pointer"
      onClick={() => onSelect(filterContacts[index])}
    >
      <Grid item xs={10}>
        <p className="font-bold">{el?.fullName}</p>
        <p
          style={{
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {el?.address}
        </p>
      </Grid>
      <Grid
        container
        item
        alignItems="center"
        justifyContent="center"
        xs={2}
      >
        <Link to={`contacts/edit?mobile=${el.mobile}`}>
          <RonadIcons
            name="edit"
            title="ویرایش"
            className="ml-2"
            style={{color: '#3449B0'}}
          />
        </Link>
        <RonadIcons
          name="trash"
          title="حذف"
          className="text-danger"
          onClick={(e) => onDelete(e,el.id)}
        />
      </Grid>
    </Grid>
  )) : <Typography variant='h4' align='center'>مخاطبی وجود ندارد</Typography>}</>
   );
}

export default ContactList;